<template>
	<section>

  <transition-group name="flip-list" tag="ul" :class="['my_list','minutes']">
    <li 
      v-for="(result,index) in sortedArray" 
      :key="index+'_'+result.psp_id"

      :class="['psp_'+result.psp_id, getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
       }]"
        ><div class="container">
          <span class="logo_provider" :style="{backgroundImage: 'url('+ getLogoPsp(result.psp_id) +')'}"></span> 
          <div :class="['monito_score',getColorScore(getScore(result.psp_id))]"><svg class="progress-ring" height="56" width="56">
          	<circle
   				stroke="#e6e6e64d"
    			stroke-width="4"
    			fill="transparent"
    			r="20"
    			cx="28"
    			cy="28"/>
          	<circle
    			class="progress-ring-circle"
   				stroke="#f00"
   				:style="'strokeDasharray: '+  getMonitoScore(getScore(result.psp_id)) +' 125'"
    			stroke-width="4"
    			fill="transparent"
    			r="20"
    			cx="28"
    			cy="28"/>
    			
    		</svg><span class="score">{{ getScore(result.psp_id) }}</span></div>
          <div class="container_amount">
            <div class="illustration_amount impact_green">
              <div :style="{width : getTransferBar(result.costs.total_received_destination)}" class="anim_element"></div>
            </div>
          </div>
          <span class="amount">
          {{ virgule_rec(result.costs.total_received_destination) }}</span>
          <span class="total_cost" style="font-weight: bold;  font-size: 14px; ">{{ virgule(result.costs.total_fees) }}</span>
          <a :href="getPspLink(result.psp_id)">Go to <span>{{ getPspName(result.psp_id) }}</span></a>
    </div></li>
  </transition-group>
	</section>
    
</template>

<script>
	export default {
		data(){
			return{

			}
		},
		methods : {
			getScore(psp_id){
				if (this.info.psp_list.find(item => item.id == psp_id).reviews.hasOwnProperty("score") == true){
				  return this.info.psp_list.find(item => item.id == psp_id).reviews.score.global
				}
			  //
			},
			hasMonitoScore(psp_id){
				this.info.psp_list.find(item => item.id == psp_id).reviews.hasOwnProperty("score")
			},
			getMonitoScore(score){
				var essai = (score * 10) * 1.25;
				return essai;
			},
			getColorScore(score){
				if(score > '8.5'){
					return 'excellent';
				} else if(score > '7'){
					return 'good';
				} else if(score > '6'){
					return 'average';
				} else if(score > '5'){
					return 'poor';
				} else {
					return 'bad';
				}
			}
		},
		props:['sortedArray','getTransferScore','info','getLogoPsp','getTransferBar','virgule_rec','virgule','getPspLink','getPspName']
	}
</script>

<style lang="scss" scoped>

	li .container_amount .illustration_amount .anim_element {
	
	}
	.monito_score {
		transform: scale(1.2);
		width: 58px;
		height: 49px;
		margin-left: 7px;
		margin-right: 25px;
		position: relative;

		svg {
			position: absolute;
			top: -4px;
			left: 0;
		}

		.score {
			display: inline-block;
			width: 52px;
			padding-top: 15px;
			left: 2px;
			position: relative;
			box-sizing: border-box;
			height: 52px;
			text-align: center;
			font-size: 14px;
			font-family: 'Avenir Next';
      		font-weight: 700;
		}
	}
	.progress-ring-circle {
		
		transform: rotate(-90deg);
  		transform-origin: 50% 50%;
  		stroke: black;

	}

	.monito_score {
		
		&.excellent {
      color: #00a000;
      .progress-ring-circle {
        stroke: #00a000;
      }
    }
    &.good {
      color: #76c107;
      .progress-ring-circle {
        stroke: #76c107;
      }
    }
    &.average {
      color: #FF9A0A;
      .progress-ring-circle {
        stroke: #FF9A0A;
      }
    }
    &.poor {
      color: #FF5B05;
      .progress-ring-circle {
        stroke: #FF5B05;
      }
    }
    &.bad {
      color: #F5313E;
      .progress-ring-circle {
        stroke: #F5313E;
      }
    }
	}

	 
</style>


// WEBPACK FOOTER //
// src/components/BestRated.vue